

// // src/components/Task/CreateTaskModal.jsx
// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";

// export default function CreateTaskModal({
//   open,
//   onClose,
//   defaultModule = "",
//   defaultRecord = null, // { id, uid, name }
// }) {
//   const [users, setUsers] = useState([]);
//   const [approvers, setApprovers] = useState([]);

//   const [form, setForm] = useState({
//     title: "",
//     module: defaultModule || "General",
//     related_record_id: defaultRecord?.id || "",
//     related_record_uid: defaultRecord?.uid || "",
//     related_record_name: defaultRecord?.name || "",
//     assigned_to: "",
//     priority: "Medium",
//     start_date: "",
//     due_date: "",
//     needs_approval: false,
//     approver_id: "",
//     notes: "",
//   });

//   useEffect(() => {
//     if (open) {
//       // Load users
//       api
//         .get("/users")
//         .then((res) => {
//           const allUsers = res.data.users || [];
//           setUsers(allUsers);

//           // Filter managers for approver dropdown
//           const managers = allUsers.filter((u) =>
//             ["SuperAdmin", "Admin", "TeamLead"].includes(u.role)
//           );
//           setApprovers(managers);
//         })
//         .catch(() => {
//           alert("Failed to load users");
//         });

//       // Pre-fill related record if passed
//       setForm((prev) => ({
//         ...prev,
//         module: defaultModule || "General",
//         related_record_id: defaultRecord?.id || "",
//         related_record_uid: defaultRecord?.uid || "",
//         related_record_name: defaultRecord?.name || "",
//       }));
//     }
//   }, [open, defaultModule, defaultRecord]);

//   const handleSubmit = async () => {
//     if (!form.title.trim()) return alert("Task Title is required");
//     if (!form.assigned_to) return alert("Please assign the task to a user");
//     if (form.needs_approval && !form.approver_id) return alert("Please select an approver");

//     try {
//       await api.post("/tasks", {
//         title: form.title.trim(),
//         module: form.module,
//         related_record_id: form.related_record_id || null,
//         related_record_uid: form.related_record_uid || null,
//         related_record_name: form.related_record_name || null,
//         assigned_to: Number(form.assigned_to),
//         priority: form.priority,
//         start_date: form.start_date || null,
//         due_date: form.due_date || null,
//         requires_approval: form.needs_approval,
//         approver_id: form.needs_approval ? Number(form.approver_id) : null,
//         notes: form.notes.trim() || null,
//       });

//       onClose(true); // success → refresh tasks
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to create task");
//     }
//   };

//   if (!open) return null;

//   const relatedDisplay =
//     form.related_record_uid && form.related_record_name
//       ? `${form.related_record_uid} — ${form.related_record_name}`
//       : form.related_record_name || "—";

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//         {/* Header */}
//         <div className="p-6 border-b border-gray-200">
//           <h2 className="text-3xl font-bold text-center text-gray-900">Create Task</h2>
//         </div>

//         {/* Form Body */}
//         <div className="p-8 space-y-7">
//           {/* Task Title */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">
//               Task Title <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="text"
//               placeholder="Enter task title"
//               value={form.title}
//               onChange={(e) => setForm({ ...form, title: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
//             />
//           </div>

//           {/* Module */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">Module</label>
//             <select
//               value={form.module}
//               onChange={(e) => setForm({ ...form, module: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//             >
//               <option>General</option>
//               <option>Lead</option>
//               <option>Project</option>
//               <option>Invoice</option>
//               <option>Service</option>
//               <option>HR</option>
//               <option>Accounts</option>
//             </select>
//           </div>

//           {/* Related Record */}
//           {form.module !== "General" && (
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">Related Record</label>
//               <div className="w-full px-6 py-4 border border-gray-300 rounded-xl bg-gray-50 text-gray-800 font-medium text-lg">
//                 {relatedDisplay}
//               </div>
//             </div>
//           )}

//           {/* Assigned To */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">
//               Assigned To <span className="text-red-500">*</span>
//             </label>
//             <select
//               value={form.assigned_to}
//               onChange={(e) => setForm({ ...form, assigned_to: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//             >
//               <option value="">Select User</option>
//               {users.map((u) => (
//                 <option key={u.id} value={u.id}>
//                   {u.name} ({u.role})
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Priority */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">Priority</label>
//             <select
//               value={form.priority}
//               onChange={(e) => setForm({ ...form, priority: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//             >
//               <option>Low</option>
//               <option>Medium</option>
//               <option>High</option>
//               <option>Urgent</option>
//             </select>
//           </div>

//           {/* Dates */}
//           <div className="grid grid-cols-2 gap-8">
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">Start Date</label>
//               <input
//                 type="date"
//                 value={form.start_date}
//                 onChange={(e) => setForm({ ...form, start_date: e.target.value })}
//                 className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
//               />
//             </div>
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">Due Date</label>
//               <input
//                 type="date"
//                 value={form.due_date}
//                 onChange={(e) => setForm({ ...form, due_date: e.target.value })}
//                 className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
//               />
//             </div>
//           </div>

//           {/* Needs Approval */}
//           <div className="py-6 border-t border-gray-200">
//             <label className="flex items-center gap-4 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={form.needs_approval}
//                 onChange={(e) => setForm({ ...form, needs_approval: e.target.checked })}
//                 className="w-6 h-6 text-orange-600 rounded focus:ring-orange-500"
//               />
//               <span className="text-xl font-semibold text-gray-800">Needs Approval?</span>
//             </label>

//             {form.needs_approval && (
//               <div className="mt-6">
//                 <label className="block text-lg font-semibold text-gray-800 mb-2">
//                   Select Approver <span className="text-red-500">*</span>
//                 </label>
//                 <select
//                   value={form.approver_id}
//                   onChange={(e) => setForm({ ...form, approver_id: e.target.value })}
//                   className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//                 >
//                   <option value="">Choose Approver</option>
//                   {approvers.map((u) => (
//                     <option key={u.id} value={u.id}>
//                       {u.name} ({u.role})
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </div>

//           {/* Notes */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">Notes</label>
//             <textarea
//               rows={5}
//               placeholder="Add any additional details..."
//               value={form.notes}
//               onChange={(e) => setForm({ ...form, notes: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"
//             />
//           </div>
//         </div>

//         {/* Footer Buttons */}
//         <div className="flex justify-center gap-10 p-8 border-t border-gray-200">
//           <button
//             onClick={() => onClose(false)}
//             className="px-16 py-5 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold text-xl rounded-xl transition"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-16 py-5 bg-[#0f172a] hover:bg-orange-600 text-white font-bold text-xl rounded-xl shadow-lg transition"
//           >
//             Create Task
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


// // src/components/Task/CreateTaskModal.jsx
// import React, { useState, useEffect, useRef } from "react";
// import api from "../../utils/api";

// export default function CreateTaskModal({
//   open,
//   onClose,
//   defaultModule = "",
//   defaultRecord = null, // { id, uid, name }
// }) {
//   const [users, setUsers] = useState([]);
//   const [approvers, setApprovers] = useState([]);

//   // Lead search state
//   const [leadSearch, setLeadSearch] = useState("");
//   const [leadResults, setLeadResults] = useState([]);
//   const [searching, setSearching] = useState(false);

//   const [form, setForm] = useState({
//     title: "",
//     module: defaultModule || "General",
//     related_record_id: defaultRecord?.id || "",
//     related_record_uid: defaultRecord?.uid || "",
//     related_record_name: defaultRecord?.name || "",
//     related_record_mobile: "", // added for better display
//     assigned_to: "",
//     priority: "Medium",
//     start_date: "",
//     due_date: "",
//     needs_approval: false,
//     approver_id: "",
//     notes: "",
//   });

//   const titleInputRef = useRef(null);

//   // Reset related record when module changes to non-Lead
//   useEffect(() => {
//     if (form.module !== "Lead") {
//       setForm((prev) => ({
//         ...prev,
//         related_record_id: "",
//         related_record_uid: "",
//         related_record_name: "",
//         related_record_mobile: "",
//       }));
//       setLeadSearch("");
//       setLeadResults([]);
//     }
//   }, [form.module]);

//   // Load users, pre-fill, and focus title
//   useEffect(() => {
//     if (open) {
//       // Load users
//       api
//         .get("/users")
//         .then((res) => {
//           const allUsers = res.data.users || [];
//           setUsers(allUsers);
//           const managers = allUsers.filter((u) =>
//             ["SuperAdmin", "Admin", "TeamLead"].includes(u.role)
//           );
//           setApprovers(managers);
//         })
//         .catch(() => alert("Failed to load users"));

//       // Pre-fill if opened from lead detail
//       if (defaultRecord && defaultModule === "Lead") {
//         setForm((prev) => ({
//           ...prev,
//           related_record_id: defaultRecord.id,
//           related_record_uid: defaultRecord.uid,
//           related_record_name: defaultRecord.name,
//           related_record_mobile: defaultRecord.mobile || "",
//         }));
//       }

//       // Auto-focus title input
//       setTimeout(() => titleInputRef.current?.focus(), 100);
//     }
//   }, [open, defaultModule, defaultRecord]);

//   // Enhanced lead search with auto-select
//   useEffect(() => {
//     if (form.module !== "Lead" || !leadSearch.trim()) {
//       setLeadResults([]);
//       setSearching(false);
//       return;
//     }

//     const query = leadSearch.trim();
//     const isLeadIdPattern = /^LW-\d{6,}$/.test(query);

//     const delay = isLeadIdPattern ? 300 : 600;

//     const timer = setTimeout(async () => {
//       setSearching(true);
//       try {
//         const res = await api.get(`/tasks/search-leads?q=${encodeURIComponent(query)}`);
//         const leads = res.data.leads || [];
//         setLeadResults(leads);

//         // Auto-select on exact match
//         if (
//           leads.length === 1 &&
//           leads[0].lead_uid.toUpperCase() === query.toUpperCase()
//         ) {
//           const lead = leads[0];
//           setForm((prev) => ({
//             ...prev,
//             related_record_id: lead.id,
//             related_record_uid: lead.lead_uid,
//             related_record_name: lead.name,
//             related_record_mobile: lead.mobile || "",
//           }));
//           setLeadSearch("");
//           setLeadResults([]);
//         }
//       } catch (err) {
//         console.error("Lead search failed:", err);
//         setLeadResults([]);
//       } finally {
//         setSearching(false);
//       }
//     }, delay);

//     return () => clearTimeout(timer);
//   }, [leadSearch, form.module]);

//   const handleSubmit = async () => {
//     if (!form.title.trim()) return alert("Task Title is required");
//     if (!form.assigned_to) return alert("Please assign the task to a user");
//     if (form.module === "Lead" && !form.related_record_id)
//       return alert("Please select a Lead");
//     if (form.needs_approval && !form.approver_id)
//       return alert("Please select an approver");

//     let department = "Management";
//     if (form.module === "Lead") department = "Sales";
//     else if (form.module === "Project") department = "Design";
//     else if (["Invoice", "Accounts"].includes(form.module)) department = "Accounts";
//     else if (form.module === "Service") department = "Production";

//     try {
//       await api.post("/tasks", {
//         title: form.title.trim(),
//         description: form.notes.trim() || null,
//         module: form.module,
//         lead_id: form.module === "Lead" ? Number(form.related_record_id) : null,
//         department,
//         assigned_to: Number(form.assigned_to),
//         priority: form.priority,
//         start_date: form.start_date || null,
//         due_date: form.due_date || null,
//         requires_approval: form.needs_approval,
//         approver_id: form.needs_approval ? Number(form.approver_id) : null,
//       });

//       onClose(true);
//     } catch (err) {
//       console.error(err);
//       alert(err?.response?.data?.message || "Failed to create task");
//     }
//   };

//   const clearLeadSelection = () => {
//     setForm((prev) => ({
//       ...prev,
//       related_record_id: "",
//       related_record_uid: "",
//       related_record_name: "",
//       related_record_mobile: "",
//     }));
//     setLeadSearch("");
//   };

//   if (!open) return null;

//   const selectedLeadDisplay = form.related_record_uid
//     ? `${form.related_record_uid} — ${form.related_record_name || "Unknown"}${
//         form.related_record_mobile ? ` (${form.related_record_mobile})` : ""
//       }`
//     : "No lead selected";

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//         {/* Header */}
//         <div className="p-6 border-b border-gray-200">
//           <h2 className="text-3xl font-bold text-center text-gray-900">Create Task</h2>
//         </div>

//         {/* Form Body */}
//         <div className="p-8 space-y-7">
//           {/* Task Title */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">
//               Task Title <span className="text-red-500">*</span>
//             </label>
//             <input
//               ref={titleInputRef}
//               type="text"
//               placeholder="Enter task title"
//               value={form.title}
//               onChange={(e) => setForm({ ...form, title: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
//             />
//           </div>

//           {/* Module */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">Module</label>
//             <select
//               value={form.module}
//               onChange={(e) => setForm({ ...form, module: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//             >
//               <option>General</option>
//               <option>Lead</option>
//               <option>Project</option>
//               <option>Invoice</option>
//               <option>Service</option>
//               <option>HR</option>
//               <option>Accounts</option>
//             </select>
//           </div>

//           {/* Lead Search & Selection */}
//           {form.module === "Lead" && (
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">
//                 Related Lead <span className="text-red-500">*</span>
//               </label>

//               {/* Search Input */}
//               <input
//                 type="text"
//                 placeholder="Type Lead ID (e.g. LW-000019), Name, or Mobile..."
//                 value={leadSearch}
//                 onChange={(e) => setLeadSearch(e.target.value)}
//                 className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 mb-3"
//                 autoFocus={form.module === "Lead"}
//               />

//               {/* Selected Lead Display */}
//               <div
//                 className={`w-full px-6 py-4 rounded-xl text-lg font-medium transition-all flex items-center justify-between
//                   ${form.related_record_id
//                     ? "bg-orange-50 border-2 border-orange-400 text-gray-900 shadow-sm"
//                     : "bg-gray-100 border border-dashed border-gray-400 text-gray-500"
//                   }`}
//               >
//                 <span>{form.related_record_id ? selectedLeadDisplay : "— No lead selected —"}</span>
//                 {form.related_record_id && (
//                   <button
//                     onClick={clearLeadSelection}
//                     className="text-red-600 hover:text-red-800 text-sm font-medium ml-4"
//                   >
//                     Clear
//                   </button>
//                 )}
//               </div>

//               {/* Loading */}
//               {searching && (
//                 <div className="mt-4 text-center text-gray-600">
//                   <span className="inline-block animate-pulse">Searching leads...</span>
//                 </div>
//               )}

//               {/* No Results */}
//               {leadSearch.trim().length >= 3 && !searching && leadResults.length === 0 && (
//                 <div className="mt-4 text-center text-orange-600 bg-orange-50 py-3 rounded-lg font-medium">
//                   No leads found for "{leadSearch}"
//                 </div>
//               )}

//               {/* Search Results */}
//               {leadResults.length > 0 && (
//                 <div className="mt-4 max-h-64 overflow-y-auto border border-gray-300 rounded-xl bg-white shadow-xl divide-y divide-gray-200">
//                   {leadResults.map((lead) => (
//                     <div
//                       key={lead.id}
//                       onClick={() => {
//                         setForm((prev) => ({
//                           ...prev,
//                           related_record_id: lead.id,
//                           related_record_uid: lead.lead_uid,
//                           related_record_name: lead.name,
//                           related_record_mobile: lead.mobile || "",
//                         }));
//                         setLeadSearch("");
//                         setLeadResults([]);
//                       }}
//                       className="px-6 py-4 hover:bg-orange-50 cursor-pointer transition flex justify-between items-center"
//                     >
//                       <div>
//                         <div className="font-bold text-gray-900">
//                           {lead.lead_uid} — {lead.name}
//                         </div>
//                         <div className="text-sm text-gray-600 mt-1">
//                           Mobile: {lead.mobile || "—"}
//                         </div>
//                       </div>
//                       <span className="text-orange-600 font-medium text-sm">Select →</span>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Tip */}
//               {leadSearch.trim().length >= 8 && leadSearch.startsWith("LW-") && !searching && leadResults.length === 0 && (
//                 <div className="mt-4 text-sm text-amber-700 bg-amber-50 p-4 rounded-lg">
//                   Tip: Double-check the Lead ID spelling. It must exist in the system.
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Static Related Record for other modules */}
//           {form.module !== "General" && form.module !== "Lead" && (
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">Related Record</label>
//               <div className="w-full px-6 py-4 border border-gray-300 rounded-xl bg-gray-50 text-gray-800 font-medium text-lg">
//                 {selectedLeadDisplay}
//               </div>
//             </div>
//           )}

        //   {/* Assigned To */}
        //   <div>
        //     <label className="block text-lg font-semibold text-gray-800 mb-2">
        //       Assigned To <span className="text-red-500">*</span>
        //     </label>
        //     <select
        //       value={form.assigned_to}
        //       onChange={(e) => setForm({ ...form, assigned_to: e.target.value })}
        //       className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
        //     >
        //       <option value="">Select User</option>
        //       {users.map((u) => (
        //         <option key={u.id} value={u.id}>
        //           {u.name} ({u.role})
        //         </option>
        //       ))}
        //     </select>
        //   </div>

        //   {/* Priority */}
        //   <div>
        //     <label className="block text-lg font-semibold text-gray-800 mb-2">Priority</label>
        //     <select
        //       value={form.priority}
        //       onChange={(e) => setForm({ ...form, priority: e.target.value })}
        //       className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
        //     >
        //       <option>Low</option>
        //       <option>Medium</option>
        //       <option>High</option>
        //       <option>Urgent</option>
        //     </select>
        //   </div>

        //   {/* Dates */}
        //   <div className="grid grid-cols-2 gap-8">
        //     <div>
        //       <label className="block text-lg font-semibold text-gray-800 mb-2">Start Date</label>
        //       <input
        //         type="date"
        //         value={form.start_date}
        //         onChange={(e) => setForm({ ...form, start_date: e.target.value })}
        //         className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
        //       />
        //     </div>
        //     <div>
        //       <label className="block text-lg font-semibold text-gray-800 mb-2">Due Date</label>
        //       <input
        //         type="date"
        //         value={form.due_date}
        //         onChange={(e) => setForm({ ...form, due_date: e.target.value })}
        //         className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
        //       />
        //     </div>
        //   </div>

        //   {/* Needs Approval */}
        //   <div className="py-6 border-t border-gray-200">
        //     <label className="flex items-center gap-4 cursor-pointer">
        //       <input
        //         type="checkbox"
        //         checked={form.needs_approval}
        //         onChange={(e) => setForm({ ...form, needs_approval: e.target.checked })}
        //         className="w-6 h-6 text-orange-600 rounded focus:ring-orange-500"
        //       />
        //       <span className="text-xl font-semibold text-gray-800">Needs Approval?</span>
        //     </label>

        //     {form.needs_approval && (
        //       <div className="mt-6">
        //         <label className="block text-lg font-semibold text-gray-800 mb-2">
        //           Select Approver <span className="text-red-500">*</span>
        //         </label>
        //         <select
        //           value={form.approver_id}
        //           onChange={(e) => setForm({ ...form, approver_id: e.target.value })}
        //           className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
        //         >
        //           <option value="">Choose Approver</option>
        //           {approvers.map((u) => (
        //             <option key={u.id} value={u.id}>
        //               {u.name} ({u.role})
        //             </option>
        //           ))}
        //         </select>
        //       </div>
        //     )}
        //   </div>

        //   {/* Notes */}
        //   <div>
        //     <label className="block text-lg font-semibold text-gray-800 mb-2">Notes</label>
        //     <textarea
        //       rows={5}
        //       placeholder="Add any additional details..."
        //       value={form.notes}
        //       onChange={(e) => setForm({ ...form, notes: e.target.value })}
        //       className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"
        //     />
        //   </div>
        // </div>

//         {/* Footer */}
//         <div className="flex justify-center gap-10 p-8 border-t border-gray-200">
//           <button
//             onClick={() => onClose(false)}
//             className="px-16 py-5 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold text-xl rounded-xl transition"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-16 py-5 bg-[#0f172a] hover:bg-orange-600 text-white font-bold text-xl rounded-xl shadow-lg transition"
//           >
//             Create Task
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // src/components/Task/CreateTaskDrawer.jsx (renamed for clarity)
// import React, { useState, useEffect, useRef } from "react";
// import api from "../../utils/api";

// export default function CreateTaskDrawer({
//   open,
//   onClose,
//   defaultModule = "",
//   defaultRecord = null,
// }) {
//   const [users, setUsers] = useState([]);
//   const [approvers, setApprovers] = useState([]);
//   const [leadSearch, setLeadSearch] = useState("");
//   const [leadResults, setLeadResults] = useState([]);
//   const [searching, setSearching] = useState(false);

//   const [form, setForm] = useState({
//     title: "",
//     module: defaultModule || "General",
//     related_record_id: defaultRecord?.id || "",
//     related_record_uid: defaultRecord?.uid || "",
//     related_record_name: defaultRecord?.name || "",
//     related_record_mobile: defaultRecord?.mobile || "",
//     assigned_to: "",
//     priority: "Medium",
//     start_date: "",
//     due_date: "",
//     needs_approval: false,
//     approver_id: "",
//     notes: "",
//   });

//   const titleInputRef = useRef(null);

//   useEffect(() => {
//     if (form.module !== "Lead") {
//       setForm(prev => ({
//         ...prev,
//         related_record_id: "",
//         related_record_uid: "",
//         related_record_name: "",
//         related_record_mobile: "",
//       }));
//       setLeadSearch("");
//       setLeadResults([]);
//     }
//   }, [form.module]);

//   useEffect(() => {
//     if (open) {
//       api.get("/users").then(res => {
//         const allUsers = res.data.users || [];
//         setUsers(allUsers);
//         setApprovers(allUsers.filter(u => ["SuperAdmin", "Admin", "TeamLead"].includes(u.role)));
//       }).catch(() => alert("Failed to load users"));

//       if (defaultRecord && defaultModule === "Lead") {
//         setForm(prev => ({
//           ...prev,
//           related_record_id: defaultRecord.id,
//           related_record_uid: defaultRecord.uid,
//           related_record_name: defaultRecord.name,
//           related_record_mobile: defaultRecord.mobile || "",
//         }));
//       }

//       setTimeout(() => titleInputRef.current?.focus(), 100);
//     }
//   }, [open, defaultModule, defaultRecord]);

//   // Lead search logic (same as before)
//   useEffect(() => {
//     if (form.module !== "Lead" || !leadSearch.trim()) {
//       setLeadResults([]);
//       setSearching(false);
//       return;
//     }

//     const query = leadSearch.trim();
//     const delay = /^LW-\d{6,}$/.test(query) ? 300 : 600;

//     const timer = setTimeout(async () => {
//       setSearching(true);
//       try {
//         const res = await api.get(`/tasks/search-leads?q=${encodeURIComponent(query)}`);
//         const leads = res.data.leads || [];
//         setLeadResults(leads);

//         if (leads.length === 1 && leads[0].lead_uid.toUpperCase() === query.toUpperCase()) {
//           const lead = leads[0];
//           setForm(prev => ({
//             ...prev,
//             related_record_id: lead.id,
//             related_record_uid: lead.lead_uid,
//             related_record_name: lead.name,
//             related_record_mobile: lead.mobile || "",
//           }));
//           setLeadSearch("");
//           setLeadResults([]);
//         }
//       } catch (err) {
//         console.error("Lead search failed:", err);
//       } finally {
//         setSearching(false);
//       }
//     }, delay);

//     return () => clearTimeout(timer);
//   }, [leadSearch, form.module]);

//   const handleSubmit = async () => {
//     if (!form.title.trim()) return alert("Task Title is required");
//     if (!form.assigned_to) return alert("Please assign the task");
//     if (form.module === "Lead" && !form.related_record_id) return alert("Please select a Lead");
//     if (form.needs_approval && !form.approver_id) return alert("Please select an approver");

//     const department = form.module === "Lead" ? "Sales" :
//       form.module === "Project" ? "Design" :
//       ["Invoice", "Accounts"].includes(form.module) ? "Accounts" :
//       form.module === "Service" ? "Production" : "Management";

//     try {
//       await api.post("/tasks", {
//         title: form.title.trim(),
//         description: form.notes.trim() || null,
//         module: form.module,
//         lead_id: form.module === "Lead" ? Number(form.related_record_id) : null,
//         department,
//         assigned_to: Number(form.assigned_to),
//         priority: form.priority,
//         start_date: form.start_date || null,
//         due_date: form.due_date || null,
//         requires_approval: form.needs_approval,
//         approver_id: form.needs_approval ? Number(form.approver_id) : null,
//       });

//       onClose(true);
//     } catch (err) {
//       alert(err?.response?.data?.message || "Failed to create task");
//     }
//   };

//   const clearLead = () => {
//     setForm(prev => ({
//       ...prev,
//       related_record_id: "",
//       related_record_uid: "",
//       related_record_name: "",
//       related_record_mobile: "",
//     }));
//     setLeadSearch("");
//   };

//   if (!open) return null;

//   const selectedLead = form.related_record_uid
//     ? `${form.related_record_uid} — ${form.related_record_name}${form.related_record_mobile ? ` (${form.related_record_mobile})` : ""}`
//     : "No lead selected";

//   return (
//     <div className={`fixed inset-0 z-50 ${open ? "pointer-events-auto" : "pointer-events-none"}`}>
//       {/* Backdrop */}
//       <div
//         className={`absolute inset-0 bg-black transition-opacity duration-300 ${
//           open ? "opacity-50" : "opacity-0"
//         }`}
//         onClick={() => onClose(false)}
//       />

//       {/* Drawer */}
//       <div className={`absolute right-0 top-0 h-full w-full max-w-lg bg-white shadow-2xl transform transition-transform duration-300 ${
//         open ? "translate-x-0" : "translate-x-full"
//       }`}>
//         <div className="flex items-center justify-between p-6 border-b">
//           <h2 className="text-2xl font-bold text-gray-900">Create New Task</h2>
//           <button
//             onClick={() => onClose(false)}
//             className="p-2 rounded-lg hover:bg-gray-100"
//           >
//             ✕
//           </button>
//         </div>

//         <div className="p-8 space-y-6 overflow-y-auto h-full pb-32">
//           {/* Title */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Task Title <span className="text-red-500">*</span>
//             </label>
//             <input
//               ref={titleInputRef}
//               type="text"
//               value={form.title}
//               onChange={e => setForm({ ...form, title: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               placeholder="Enter task title"
//             />
//           </div>

//           {/* Module */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Module</label>
//             <select
//               value={form.module}
//               onChange={e => setForm({ ...form, module: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//             >
//               <option>General</option>
//               <option>Lead</option>
//               <option>Project</option>
//               <option>Invoice</option>
//               <option>Service</option>
//               <option>HR</option>
//               <option>Accounts</option>
//             </select>
//           </div>

//           {/* Lead Search */}
//           {form.module === "Lead" && (
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Related Lead <span className="text-red-500">*</span>
//               </label>
//               <input
//                 type="text"
//                 value={leadSearch}
//                 onChange={e => setLeadSearch(e.target.value)}
//                 placeholder="Search by Lead ID, name, or mobile..."
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg mb-3 focus:ring-2 focus:ring-blue-500"
//               />

//               <div className={`p-4 rounded-lg border ${form.related_record_id ? "bg-blue-50 border-blue-300" : "bg-gray-50 border-gray-300"}`}>
//                 <div className="flex justify-between items-center">
//                   <span className="font-medium">
//                     {form.related_record_id ? selectedLead : "— No lead selected —"}
//                   </span>
//                   {form.related_record_id && (
//                     <button onClick={clearLead} className="text-red-600 text-sm hover:underline">
//                       Clear
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* Results */}
//               {leadResults.length > 0 && (
//                 <div className="mt-4 max-h-60 overflow-y-auto border rounded-lg bg-white shadow">
//                   {leadResults.map(lead => (
//                     <div
//                       key={lead.id}
//                       onClick={() => {
//                         setForm(prev => ({
//                           ...prev,
//                           related_record_id: lead.id,
//                           related_record_uid: lead.lead_uid,
//                           related_record_name: lead.name,
//                           related_record_mobile: lead.mobile || "",
//                         }));
//                         setLeadSearch("");
//                         setLeadResults([]);
//                       }}
//                       className="p-4 hover:bg-blue-50 cursor-pointer border-b last:border-0"
//                     >
//                       <div className="font-medium">{lead.lead_uid} — {lead.name}</div>
//                       <div className="text-sm text-gray-600">Mobile: {lead.mobile || "—"}</div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Rest of fields... (same as before, simplified) */}
//           {/* Assigned To, Priority, Dates, Approval, Notes — keep your existing ones */}
//           {/* ... (copy from your original code) */}
// {/* Assigned To */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">
//               Assigned To <span className="text-red-500">*</span>
//             </label>
//             <select
//               value={form.assigned_to}
//               onChange={(e) => setForm({ ...form, assigned_to: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//             >
//               <option value="">Select User</option>
//               {users.map((u) => (
//                 <option key={u.id} value={u.id}>
//                   {u.name} ({u.role})
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Priority */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">Priority</label>
//             <select
//               value={form.priority}
//               onChange={(e) => setForm({ ...form, priority: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//             >
//               <option>Low</option>
//               <option>Medium</option>
//               <option>High</option>
//               <option>Urgent</option>
//             </select>
//           </div>

//           {/* Dates */}
//           <div className="grid grid-cols-2 gap-8">
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">Start Date</label>
//               <input
//                 type="date"
//                 value={form.start_date}
//                 onChange={(e) => setForm({ ...form, start_date: e.target.value })}
//                 className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
//               />
//             </div>
//             <div>
//               <label className="block text-lg font-semibold text-gray-800 mb-2">Due Date</label>
//               <input
//                 type="date"
//                 value={form.due_date}
//                 onChange={(e) => setForm({ ...form, due_date: e.target.value })}
//                 className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
//               />
//             </div>
//           </div>

//           {/* Needs Approval */}
//           <div className="py-6 border-t border-gray-200">
//             <label className="flex items-center gap-4 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={form.needs_approval}
//                 onChange={(e) => setForm({ ...form, needs_approval: e.target.checked })}
//                 className="w-6 h-6 text-orange-600 rounded focus:ring-orange-500"
//               />
//               <span className="text-xl font-semibold text-gray-800">Needs Approval?</span>
//             </label>

//             {form.needs_approval && (
//               <div className="mt-6">
//                 <label className="block text-lg font-semibold text-gray-800 mb-2">
//                   Select Approver <span className="text-red-500">*</span>
//                 </label>
//                 <select
//                   value={form.approver_id}
//                   onChange={(e) => setForm({ ...form, approver_id: e.target.value })}
//                   className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
//                 >
//                   <option value="">Choose Approver</option>
//                   {approvers.map((u) => (
//                     <option key={u.id} value={u.id}>
//                       {u.name} ({u.role})
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </div>

//           {/* Notes */}
//           <div>
//             <label className="block text-lg font-semibold text-gray-800 mb-2">Notes</label>
//             <textarea
//               rows={5}
//               placeholder="Add any additional details..."
//               value={form.notes}
//               onChange={(e) => setForm({ ...form, notes: e.target.value })}
//               className="w-full px-6 py-4 border border-gray-300 rounded-xl text-lg focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"
//             />
//           </div>
//         </div>
        

//         {/* Footer */}
//         <div className="absolute bottom-0 left-0 right-0 bg-white border-t p-6 flex justify-end gap-4">
//           <button
//             onClick={() => onClose(false)}
//             className="px-8 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
//           >
//             Create Task
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


// src/components/Task/CreateTaskDrawer.jsx
import React, { useState, useEffect, useRef } from "react";
import api from "../../utils/api";

export default function CreateTaskDrawer({
  open,
  onClose,
  defaultModule = "",
  defaultRecord = null,
}) {
  const [users, setUsers] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [leadSearch, setLeadSearch] = useState("");
  const [leadResults, setLeadResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const [form, setForm] = useState({
    title: "",
    module: defaultModule || "General",
    related_record_id: defaultRecord?.id || "",
    related_record_uid: defaultRecord?.uid || "",
    related_record_name: defaultRecord?.name || "",
    related_record_mobile: defaultRecord?.mobile || "",
    assigned_to: "",
    priority: "Medium",
    start_date: "",
    due_date: "",
    needs_approval: false,
    approver_id: "",
    notes: "",
  });

  const titleInputRef = useRef(null);

  // Reset when module changes
  useEffect(() => {
    if (form.module !== "Lead") {
      setForm(prev => ({
        ...prev,
        related_record_id: "",
        related_record_uid: "",
        related_record_name: "",
        related_record_mobile: "",
      }));
      setLeadSearch("");
      setLeadResults([]);
    }
  }, [form.module]);

  // Load users & pre-fill
  useEffect(() => {
    if (open) {
      api.get("/users").then(res => {
        const allUsers = res.data.users || [];
        setUsers(allUsers);
        setApprovers(allUsers.filter(u => ["SuperAdmin", "Admin", "TeamLead"].includes(u.role)));
      }).catch(() => alert("Failed to load users"));

      if (defaultRecord && defaultModule === "Lead") {
        setForm(prev => ({
          ...prev,
          related_record_id: defaultRecord.id,
          related_record_uid: defaultRecord.uid,
          related_record_name: defaultRecord.name,
          related_record_mobile: defaultRecord.mobile || "",
        }));
      }

      setTimeout(() => titleInputRef.current?.focus(), 100);
    }
  }, [open, defaultModule, defaultRecord]);

  // Lead search
  useEffect(() => {
    if (form.module !== "Lead" || !leadSearch.trim()) {
      setLeadResults([]);
      setSearching(false);
      return;
    }

    const query = leadSearch.trim();
    const delay = /^LW-\d{6,}$/.test(query) ? 300 : 600;

    const timer = setTimeout(async () => {
      setSearching(true);
      try {
        const res = await api.get(`/tasks/search-leads?q=${encodeURIComponent(query)}`);
        const leads = res.data.leads || [];
        setLeadResults(leads);

        if (leads.length === 1 && leads[0].lead_uid.toUpperCase() === query.toUpperCase()) {
          const lead = leads[0];
          setForm(prev => ({
            ...prev,
            related_record_id: lead.id,
            related_record_uid: lead.lead_uid,
            related_record_name: lead.name,
            related_record_mobile: lead.mobile || "",
          }));
          setLeadSearch("");
          setLeadResults([]);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setSearching(false);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [leadSearch, form.module]);

  const handleSubmit = async () => {
    if (!form.title.trim()) return alert("Task Title is required");
    if (!form.assigned_to) return alert("Please assign the task");
    if (form.module === "Lead" && !form.related_record_id) return alert("Please select a Lead");
    if (form.needs_approval && !form.approver_id) return alert("Please select an approver");

    const department = form.module === "Lead" ? "Sales" :
      form.module === "Project" ? "Design" :
      ["Invoice", "Accounts"].includes(form.module) ? "Accounts" :
      form.module === "Service" ? "Production" : "Management";

    try {
      await api.post("/tasks", {
        title: form.title.trim(),
        description: form.notes.trim() || null,
        module: form.module,
        lead_id: form.module === "Lead" ? Number(form.related_record_id) : null,
        department,
        assigned_to: Number(form.assigned_to),
        priority: form.priority,
        start_date: form.start_date || null,
        due_date: form.due_date || null,
        requires_approval: form.needs_approval,
        approver_id: form.needs_approval ? Number(form.approver_id) : null,
      });

      onClose(true);
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to create task");
    }
  };

  const clearLead = () => {
    setForm(prev => ({
      ...prev,
      related_record_id: "",
      related_record_uid: "",
      related_record_name: "",
      related_record_mobile: "",
    }));
    setLeadSearch("");
  };

  if (!open) return null;

  const selectedLead = form.related_record_uid
    ? `${form.related_record_uid} — ${form.related_record_name}${form.related_record_mobile ? ` (${form.related_record_mobile})` : ""}`
    : "No lead selected";

  return (
    <div className={`fixed inset-0 z-50 ${open ? "pointer-events-auto" : "pointer-events-none"}`}>
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${open ? "opacity-50" : "opacity-0"}`}
        onClick={() => onClose(false)}
      />

      {/* Right Slide Drawer */}
      <div className={`absolute right-0 top-0 h-full w-full max-w-xl bg-white shadow-2xl transform transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}>
        {/* Header */}
        <div className="border-b border-gray-200 px-8 py-6">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-900">Create Task</h2>
            <button
              onClick={() => onClose(false)}
              className="p-2 rounded-lg hover:bg-gray-100 transition"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Form Body */}
        <div className="p-8 space-y-8 overflow-y-auto h-full pb-32">
          {/* Task Title */}
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">
              Task Title <span className="text-red-500">*</span>
            </label>
            <input
              ref={titleInputRef}
              type="text"
              value={form.title}
              onChange={e => setForm({ ...form, title: e.target.value })}
              placeholder="Enter task title"
              className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            />
          </div>

          {/* Module */}
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Module</label>
            <select
              value={form.module}
              onChange={e => setForm({ ...form, module: e.target.value })}
              className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            >
              <option>General</option>
              <option>Lead</option>
              <option>Project</option>
              <option>Invoice</option>
              <option>Service</option>
              <option>HR</option>
              <option>Accounts</option>
            </select>
          </div>

          {/* Related Lead (only if Lead module) */}
          {form.module === "Lead" && (
            <div>
              <label className="block text-base font-medium text-gray-700 mb-2">
                Related Lead <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={leadSearch}
                onChange={e => setLeadSearch(e.target.value)}
                placeholder="Search by Lead ID, Name, or Mobile..."
                className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
              />

              <div className={`p-5 rounded-xl border-2 ${form.related_record_id ? "bg-blue-50 border-blue-300" : "bg-gray-50 border-gray-300"}`}>
                <div className="flex items-center justify-between">
                  <span className="font-medium text-base">
                    {form.related_record_id ? selectedLead : "— No lead selected —"}
                  </span>
                  {form.related_record_id && (
                    <button onClick={clearLead} className="text-red-600 hover:text-red-800 text-sm font-medium">
                      Clear
                    </button>
                  )}
                </div>
              </div>

              {/* Search Results */}
              {leadResults.length > 0 && (
                <div className="mt-4 max-h-64 overflow-y-auto border border-gray-300 rounded-xl bg-white shadow-lg">
                  {leadResults.map(lead => (
                    <div
                      key={lead.id}
                      onClick={() => {
                        setForm(prev => ({
                          ...prev,
                          related_record_id: lead.id,
                          related_record_uid: lead.lead_uid,
                          related_record_name: lead.name,
                          related_record_mobile: lead.mobile || "",
                        }));
                        setLeadSearch("");
                        setLeadResults([]);
                      }}
                      className="px-6 py-4 hover:bg-blue-50 cursor-pointer border-b last:border-0"
                    >
                      <div className="font-semibold">{lead.lead_uid} — {lead.name}</div>
                      <div className="text-sm text-gray-600 mt-1">Mobile: {lead.mobile || "—"}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Assigned To */}
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">
              Assigned To <span className="text-red-500">*</span>
            </label>
            <select
              value={form.assigned_to}
              onChange={e => setForm({ ...form, assigned_to: e.target.value })}
              className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            >
              <option value="">Select User</option>
              {users.map(u => (
                <option key={u.id} value={u.id}>
                  {u.name} ({u.role})
                </option>
              ))}
            </select>
          </div>

          {/* Priority */}
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Priority</label>
            <select
              value={form.priority}
              onChange={e => setForm({ ...form, priority: e.target.value })}
              className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            >
              <option>Low</option>
              <option>Medium</option>
              <option>High</option>
              <option>Urgent</option>
            </select>
          </div>

          {/* Dates */}
          <div className="grid grid-cols-2 gap-8">
            <div>
              <label className="block text-base font-medium text-gray-700 mb-2">Start Date</label>
              <input
                type="date"
                value={form.start_date}
                onChange={e => setForm({ ...form, start_date: e.target.value })}
                className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-base font-medium text-gray-700 mb-2">Due Date</label>
              <input
                type="date"
                value={form.due_date}
                onChange={e => setForm({ ...form, due_date: e.target.value })}
                className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Needs Approval */}
          <div className="pt-6 border-t border-gray-200">
            <label className="flex items-center gap-4 cursor-pointer text-base">
              <input
                type="checkbox"
                checked={form.needs_approval}
                onChange={e => setForm({ ...form, needs_approval: e.target.checked })}
                className="w-6 h-6 text-blue-600 rounded focus:ring-blue-500"
              />
              <span className="font-medium text-gray-800">Needs Approval?</span>
            </label>

            {form.needs_approval && (
              <div className="mt-6">
                <label className="block text-base font-medium text-gray-700 mb-2">
                  Select Approver <span className="text-red-500">*</span>
                </label>
                <select
                  value={form.approver_id}
                  onChange={e => setForm({ ...form, approver_id: e.target.value })}
                  className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                >
                  <option value="">Choose Approver</option>
                  {approvers.map(u => (
                    <option key={u.id} value={u.id}>
                      {u.name} ({u.role})
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Notes */}
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Notes</label>
            <textarea
              rows={6}
              value={form.notes}
              onChange={e => setForm({ ...form, notes: e.target.value })}
              placeholder="Add any additional details..."
              className="w-full px-5 py-4 border border-gray-300 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            />
          </div>
        </div>

        {/* Fixed Footer */}
        <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-6">
          <div className="flex justify-end gap-4">
            <button
              onClick={() => onClose(false)}
              className="px-8 py-3.5 text-base font-medium text-gray-700 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-10 py-3.5 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-xl shadow-md transition"
            >
              Create Task
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}